module.exports = __webpack_public_path__ + "bfdb4146196b0c2a5139ab21839db0aa.pdf";